export default "__VITE_ASSET__09322e04__"